export default "__VITE_ASSET__B1xA567g__ 100w";